export default __webpack_public_path__ + "static/kb_3_9-169435d209ebda787b50fcd6f39f1448.jpg";